import { render, staticRenderFns } from "./CountdownBadge.vue?vue&type=template&id=bb3e8174"
import script from "./CountdownBadge.vue?vue&type=script&lang=js"
export * from "./CountdownBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports